import TagInputPicker from './TagInputPicker';

export default function SkillsPicker({
  selectedSkills = [],
  onChange,
  catalog = [],
  onCreateSkill,
  error,
  hint = 'Search skills, select from the list, or create a new one.',
  allowRemoveSelected = true,
  showCountBadge = true,
  menuZIndex,
  label = 'Search skills',
  placeholder = 'Search skills or type a new skill…'
}) {
  return (
    <TagInputPicker
      variant="skill"
      selected={selectedSkills}
      onChange={onChange}
      catalog={catalog}
      onCreateItem={onCreateSkill}
      error={error}
      hint={hint}
      allowRemove={allowRemoveSelected}
      showCountBadge={showCountBadge}
      label={label}
      placeholder={placeholder}
      menuZIndex={menuZIndex}
      normalizeItem={item => String(item || '').trim()}
    />
  );
}
